import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import { YouthIcon, WomenIcon, ChildrenIcon, DisabilityIcon } from './Icons';
import './TargetGroups.css';

const TargetGroups = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const targetGroups = [
    { Icon: YouthIcon, title: t.vulnerableYouth },
    { Icon: WomenIcon, title: t.vulnerableWomen },
    { Icon: ChildrenIcon, title: t.vulnerableChildren },
    { Icon: DisabilityIcon, title: t.personsWithDisabilities }
  ];

  return (
    <section id="target-groups" className="target-groups">
      <div className="container">
        <div className="section-header">
          <h2>{t.targetGroupsTitle}</h2>
          <p>{t.targetGroupsIntro}</p>
        </div>

        <div className="target-groups-grid">
          {targetGroups.map((group, index) => (
            <div key={index} className="target-group-card">
              <div className="target-group-icon">
                <group.Icon />
              </div>
              <h3>{group.title}</h3>
            </div>
          ))}
        </div>

        <div className="target-note">
          <p>{t.targetGroupsNote}</p>
        </div>
      </div>
    </section>
  );
};

export default TargetGroups;
